<script setup lang="ts">
import { useMap } from '@/composables';

const { isFocusedAreaTooCloseToRightEdge } = useMap();
</script>

<template>
  <div
    class="pointer-events-none gap-8 lg:grid lg:w-[calc(100dvw_-_156px)] lg:grid-cols-2 lg:grid-rows-1 lg:items-center lg:justify-between"
  >
    <div
      class="hidden h-full lg:flex lg:items-end"
      :class="isFocusedAreaTooCloseToRightEdge && 'order-1'"
    >
      <Transition :name="isFocusedAreaTooCloseToRightEdge ? 'slide-fade-left' : 'slide-fade-right'">
        <slot name="pins" />
      </Transition>
    </div>
    <div
      class="flex h-full items-end"
      :class="isFocusedAreaTooCloseToRightEdge ? 'justify-start' : 'justify-end'"
    >
      <Transition :name="isFocusedAreaTooCloseToRightEdge ? 'slide-fade-right' : 'slide-fade-left'">
        <slot name="card" />
      </Transition>
    </div>
  </div>
</template>

<style scoped>
.slide-fade-left-enter-active,
.slide-fade-left-leave-active {
  transition: all 0.3s ease-out;
}

.slide-fade-left-enter-from,
.slide-fade-left-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.slide-fade-right-enter-active,
.slide-fade-right-leave-active {
  transition: all 0.3s ease-out;
}

.slide-fade-right-enter-from,
.slide-fade-right-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}
</style>
